/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountBalance } from './AccountBalance';
import {
    AccountBalanceFromJSON,
    AccountBalanceFromJSONTyped,
    AccountBalanceToJSON,
} from './AccountBalance';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';

/**
 * 
 * @export
 * @interface AccountBalanceOutput
 */
export interface AccountBalanceOutput {
    /**
     * 
     * @type {Array<AccountBalance>}
     * @memberof AccountBalanceOutput
     */
    accounts?: Array<AccountBalance>;
    /**
     * 
     * @type {Links}
     * @memberof AccountBalanceOutput
     */
    links?: Links;
    /**
     * 
     * @type {Error}
     * @memberof AccountBalanceOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the AccountBalanceOutput interface.
 */
export function instanceOfAccountBalanceOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccountBalanceOutputFromJSON(json: any): AccountBalanceOutput {
    return AccountBalanceOutputFromJSONTyped(json, false);
}

export function AccountBalanceOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountBalanceOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accounts': !exists(json, 'accounts') ? undefined : ((json['accounts'] as Array<any>).map(AccountBalanceFromJSON)),
        'links': !exists(json, '_links') ? undefined : LinksFromJSON(json['_links']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function AccountBalanceOutputToJSON(value?: AccountBalanceOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accounts': value.accounts === undefined ? undefined : ((value.accounts as Array<any>).map(AccountBalanceToJSON)),
        '_links': LinksToJSON(value.links),
        'error': value.error,
    };
}

